import type { ITariffZone } from '../../../models/tariff-zone.model';

export default class TariffZoneViewModel {
  public gid!: string;
  public name!: string;
  public number!: number;
  public shortName!: string;

  static mapToBusinessModel(tz: TariffZoneViewModel): ITariffZone {
    return {
      name: tz.name,
      number: tz.number,
      shortName: tz.shortName,
    };
  }
}
